import { baseUrl } from "./config";

/**
 * Product session API base — must match invokeApi routing.
 * Website admin has no edge /api rewrite on the SPA host; call the API origin directly.
 * Unset API_BASE_URL → same-origin /api (Vite proxy in local only).
 */
export function getWebsiteProductApiBase() {
  const origin = (baseUrl || "").replace(/\/$/, "");
  if (!origin) return "/api";
  return `${origin}/api`;
}

export function createWebsiteProductApiConfig() {
  return {
    apiBase: getWebsiteProductApiBase(),
    csrf: true,
    csrfPath: "/general_routes/csrf_token",
  };
}
